import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ReferidosService } from '../../../../services/referidos/referidos.service';
import { MatPaginator } from '@angular/material/paginator';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-modal-informacion-referido',
  templateUrl: './modal-informacion-referido.component.html',
  styleUrls: ['./modal-informacion-referido.component.css'],
})
export class ModalInformacionReferidoComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  documento!: string;
  beneficiarios: any[] = [];
  loading = false;

  displayedColumns: string[] = [
    'nombreBeneficiario',
    'numDocBeneficiario',
    'programa',
    'fechaAfiliacion',
    'estadoGestionPago',
    'fechaPagoReferente',
    'valoraPagar',
    'observaciones',
  ];

  referidoResumen: any = null;

  dataSource = new MatTableDataSource<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalInformacionReferidoComponent>,
    private referidosService: ReferidosService,
    private spinner: NgxSpinnerService
  ) {
    console.log('Datos recibidos:', data);
  }

  ngOnInit(): void {
    this.documento = this.data.documento;
    this.spinner.show();
    this.cargarBeneficiarios();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
    });
  }

  cargarBeneficiarios(): void {
    // this.loading = true;
    this.referidosService
      .getBeneficiariosPorReferidos(this.documento)
      .subscribe({
        next: (data) => {
          if (data?.length > 0) {
            const ref = data[0];

            const fechaAfiliacionTitular =
              this.obtenerFechaAfiliacionTitular(data);

              console.log("Esta es la fecha de afiliaci�n: " + data[0]);

            this.referidoResumen = {
              nombre: ref.NOMBRE_REFERIDO,
              correo: ref.CORREO_ELECTRONICO_REFERIDO,
              celular: ref.NUMERO_CELULAR_REFERIDO,
              estado:
                ref.ESTADO_REGISTRO === 'A' ? 'Vinculado' : 'Desvinculado',
              fechaAfiliacion: fechaAfiliacionTitular,
            };

            this.dataSource.data = data.map((item: any) => ({
              nombreBeneficiario: item.NOMBRE_BENEFICIARIO,
              numDocBeneficiario: item.IDENTIFICACION_BENEFICIARIO,
              programa: item.PROGRAMA,
              fechaAfiliacion: item.FECHA_DE_AFILIACION,
              estadoGestionPago: item.ESTADO_GESTION_DE_PAGO,
              fechaPagoReferente: item.FECHA_DE_PAGO_REFERENTE,
              valoraPagar: item.VALOR_A_PAGAR,
              observaciones: item.OBSERVACIONES,
            }));
          }
        },
        error: () => {
          this.spinner.hide(); 
        },
        complete: () => {
          this.spinner.hide(); 
          setTimeout(() => {
            this.dataSource.paginator = this.paginator;
            this.paginator.length = this.dataSource.data.length;
            this.paginator.pageSize = 5;
          });
        },
      });
  }

  private obtenerFechaAfiliacionTitular(beneficiarios: any[]): number | null {
    const titulares = beneficiarios.filter(
      (b) => b.PARENTESCO_BENEFICIARIO?.trim().toLowerCase() === 'titular'
    );

    if (!titulares.length) {
      return null;
    }

    return Math.max(...titulares.map((t) => Number(t.FECHA_DE_AFILIACION)));
  }
}
